import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=1bcc8a88&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bcc8a88')) {
      api.createRecord('1bcc8a88', component.options)
    } else {
      api.reload('1bcc8a88', component.options)
    }
    module.hot.accept("./BaseInfo.vue?vue&type=template&id=1bcc8a88&", function () {
      api.rerender('1bcc8a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/intake/children/detail/components/BaseInfo.vue"
export default component.exports